import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { MobileNavContextProvider } from './context/mobileNavContextProvider';

ReactDOM.render(
  <React.StrictMode>
    <MobileNavContextProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MobileNavContextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
